/* unplugin-vue-components disabled */import { render } from "./mainhome_china.vue?vue&type=template&id=97d200ee&scoped=true"
import script from "./mainhome_china.vue?vue&type=script&lang=js"
export * from "./mainhome_china.vue?vue&type=script&lang=js"

import "./mainhome_china.vue?vue&type=style&index=0&id=97d200ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d200ee"]])

export default __exports__